export default {
  name: "HeroSection",

  data() {
    return ({
      hero_cards: [
        {
          key: "progress",
          label: "Progress",
          icon: "bi bi-bar-chart-fill",
          description: "On track",
        },
        {
          key: "implementation",
          label: "Implementation",
          icon: "bi bi-kanban-fill",
          description: "Monitored",
        },
        {
          key: "compliance",
          label: "Compliance",
          icon: "bi bi-shield-check",
          description: "Reviewed",
        },
        {
          key: "evidence",
          label: "Evidence",
          icon: "bi bi-folder-check",
          description: "Tracked",
        },
      ],
      portfolio_stats: [
        { value: "66", label: "Indicators in view" },
        { value: "36", label: "On track" },
        { value: "94%", label: "Mean achievement" },
      ],
      platform_features: [
        {
          title: "Progress view",
          icon: "bi bi-grid-1x2-fill",
          description: "See DBE indicators in context.",
        },
        {
          title: "Implementation focus",
          icon: "bi bi-graph-up-arrow",
          description: "Track delivery across priorities.",
        },
        {
          title: "Evidence tracking",
          icon: "bi bi-clipboard-check",
          description: "Keep reporting clear and auditable.",
        },
      ],
    });
  },
};
